import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
	HStack,
	DropdownPositioningContainer,
} from '@montel/montelpro-shared-components-v2';
import ProfileButton from './ProfileButton';
import SignOutButton from './SignOutButton';
import { StyledDivider, StyledProfileContainer } from './styles';

interface ProfileProps {
	breakpoint: string;
}

const Profile: React.FC<ProfileProps> = ({ breakpoint }) => {
	const [profileOpen, setProfileOpen] = useState(false);

	const handleOpen = () => {
		setProfileOpen(true);
	};

	const onClose = () => {
		setProfileOpen(false);
	};

	return (
		<HStack align="center" gap="md">
			<StyledDivider $breakpoint={breakpoint} />
			<DropdownPositioningContainer>
				<ProfileButton onClick={handleOpen} />
				<AnimatePresence>
					{profileOpen && (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							<StyledProfileContainer
								closeMenu={onClose}
								topPosition="3.5rem"
							>
								<SignOutButton />
							</StyledProfileContainer>
						</motion.div>
					)}
				</AnimatePresence>
			</DropdownPositioningContainer>
		</HStack>
	);
};

export default Profile;
